import { ApiError } from "@/lib/api";

// Phase 4a customer-portal — pull a customer-friendly message out
// of a thrown error. Rails JSON validation errors land as
// `{ errors: { field: ["message", ...] } }`, server-rejection codes
// as `{ error: "code", message: "human text" }`. Without this
// helper, mutation `onError` would surface the generic "API 422"
// fallback that ApiError uses as `.message`.
export function readApiErrorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    const body = err.body as
      | { errors?: Record<string, string[]>; message?: string; error?: string }
      | null;
    if (body?.errors) {
      const messages = Object.values(body.errors).flat().filter(Boolean);
      if (messages.length > 0) return messages.join(", ");
    }
    if (typeof body?.message === "string" && body.message.length > 0) return body.message;
    if (typeof body?.error === "string" && body.error.length > 0) return body.error;
    return err.message;
  }
  if (err instanceof Error) return err.message;
  return "Something went wrong.";
}
